<template>
  <v-row>
    <v-col cols="12">
      <v-form
        ref="eventAttendeesForm" v-model="formValid" validate-on="input">
        <v-container>

          <v-row class="pa-2">
            <v-col cols="12">
              <h4 class="text-h6">Teilnehmer</h4>
                <v-checkbox
                  v-model="publicEvent"
                  :error-messages="errors"
                  label="Diese Veranstaltung ist öffentlich"></v-checkbox>
                <v-alert
                  prominent
                  text
                  class="d-flex align-center text-info info-banner"
                  v-if="publicEvent">
                  <v-row align="center">
                    <v-icon color="info" class="ml-4"
                      >mdi-information-outline</v-icon
                    >
                    <v-col class="grow">
                      Eine öffentliche Veranstaltung kann von jeder Person gebucht werden. Nicht öffentliche Veranstaltungen sind über einen speziellen Link zu erreichen. Der Link zu dieser Veranstaltung wird nach dem Erstellen angezeigt.
                    </v-col>
                  </v-row>
                </v-alert>
                <v-checkbox
                  v-model="needsRegistration"
                  :error-messages="errors"
                  label="Teilnehmer müssen sich anmelden"></v-checkbox>
                <v-text-field
                  v-model="maxAttendees"
                  v-if="needsRegistration"
                  bg-color="accent"
                  variant="filled"
                  label="Max. Anzahl Teilnehmer"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pa-2">
            <v-col cols="12">
              <h4 class="text-h6">Preise</h4>
                <v-checkbox
                  v-model="free"
                  label="Diese Veranstaltung ist kostenlos"></v-checkbox>
              <v-card class="pa-4 mb-4 mx-auto" rounded="xl" v-for="category in priceCategories" :key="category.id">
                <div class="d-flex justify-space-between">
                  <h2 class="mb-2">Preiskategorie {{ category.name }}</h2>
                  <v-tooltip location="bottom" offset-y>
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" density="compact" absolute location="top right"  icon variant="text" color="white" class="bg-error" @click="removeEventCategory(category.id)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Entfernen</span>
                </v-tooltip>
                </div>
                <v-row>
                  <v-col cols="12" md="8">
                    <v-text-field
                      bg-color="accent"
                      variant="filled"
                      v-model="category.name"
                      label="Name der Preiskategorie"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      bg-color="accent"
                      variant="filled"
                      model-value="10.00"
                      suffix="€"
                      v-model="category.price"
                      label="Preis"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
              <v-col cols="12" class="d-flex align-center justify-center">
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn class="bg-primary align-center" color="white" v-bind="props" size="large" icon variant="text" @click="addNewCategory">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Preiskategorie hinzufügen</span>
                </v-tooltip>
              </v-col>
            </v-col>
          </v-row>
        </v-container>
        <Pager :invalid="!formValid"/>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Pager from "@/components/Events/Form/Pager";
import uniqueId from "lodash/uniqueId";


export default {
  components: {
    Pager
  },
  data(){
    return{
      formValid: false,
      rules: {
        required: (value) => !!value || "Pflichtfeld",
      },
    }
  },
  methods: {
    ...mapActions({
      updateValue: "events/updateForm",
      addEventCategory: "events/addEventCategory",
      removeEventCategory: "events/removeEventCategory"
    }),
    addNewCategory() {
      this.addEventCategory({
        id: uniqueId(),
        name: "",
        price: "",
      })
    },
  },
  computed: {
    ...mapGetters({
      form: "events/form",
      priceCategories: "events/priceCategories",
    }),
    publicEvent: {
      get() {
        return this.$store.state.events.form.attendees.publicEvent
      },
      set(value) {
        this.updateValue({ parent: "attendees", field: "publicEvent", value: value });
      }
    },
    needsRegistration: {
      get() {
        return this.$store.state.events.form.attendees.needsRegistration
      },
      set(value) {
        this.updateValue({ parent: "attendees", field: "needsRegistration", value: value });
      }
    },
    free: {
      get() {
        return this.$store.state.events.form.attendees.free
      },
      set(value) {
        this.updateValue({ parent: "attendees", field: "free", value: value });
      }
    },
    maxAttendees: {
      get() {
        return this.$store.state.events.form.attendees.maxAttendees
      },
      set(value) {
        this.updateValue({ parent: "attendees", field: "maxAttendees", value: value });
      }
    },
    priceCategories: {
      get() {
        return this.$store.state.events.form.attendees.priceCategories
      },
      set(value) {
        this.updateValue({ parent: "attendees", field: "priceCategories", value: value });
      }
    },
    ...mapGetters({
      form: "events/form"
    })
  },
}
</script>

<style scoped>
.v-theme--light .info-banner {
  background-color: #e4f2fd;
}
.v-theme--dark .info-banner {
  background-color: #313F4A;
}
</style>
